import React, { Component } from 'react';

export default class landing extends Component {

	constructor(props) {
		super(props)
	}


	userCheck() {
		this.props.setData('CallType', 'Request');
		fetch(window.location.origin + window.location.pathname + 'CheckEligibleUser', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.navigate('A1')
			} else {
				this.props.navigate('A2')
			}
		})
	}
	render() {

		if (this.props.data["Participant Type"] == 'Prescriber') {
			return (
				<div width="100%" >
					<h3>{this.props.data.FirstName}, welcome to the Enteral Authorization portal. </h3>
					<hr />
					<div className="button" onClick={() => { this.userCheck() }}>Request a Prior Authorization</div>
					<div className="button" onClick={() => { this.props.setData('CallType', 'Cancel'); this.props.navigate('A2') }} >Cancel a Prior Authorization</div>
					<div className="button" onClick={() => { this.props.setData('CallType', 'Inquiry'); this.props.navigate('A2') }}>Perform an Authorization Inquiry</div>
					<div className="button" onClick={() => { this.props.navigate('D1A') }}>Medicaid Enteral Formula Coverage Criteria</div>
				</div>
			);
		} else if (this.props.data["Participant Type"] == 'Dispenser') {
			return (
				<div width="100%">
					<h3> Welcome to the <br />Enteral Authorization portal. </h3>
					<hr />
					<h5 style={{ padding: '0px 15px', maxWidth: '500px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>You must answer all questions before submitting a claim. Do not proceed unless the Enteral is in-stock and available to be dispensed at this time.</h5>

					<div className="button" onClick={() => { this.props.setData('CallType', 'Dispense'); this.props.navigate('D2') }}>Dispense an Enteral Formula</div>
					<div className="button" onClick={() => { this.props.setData('CallType', 'Inquiry'); this.props.navigate('A2') }}>Perform an Authorization Inquiry</div>
					<div className="button" onClick={() => { this.props.navigate('D1') }}>Paper Prior Approval Requests</div>
					<div className="button" onClick={() => { this.props.navigate('D1A') }}>Medicaid Enteral Coverage Criteria</div>
				</div>
			);
		}


	}
}